import * as nodeUtils from "../../../../abstract/controller/utils/nodeUtils";
import useStatus from "../../../../abstract/hook/useStatus";
import ConditionContainer from "../ConditionContainer";
import ConditionHeader from "../ConditionHeader";
import ConditionMain from "../ConditionMain";
import ConditionPanel from "../ConditionPanel";
import styles from "./ConditionStructure.module.scss";

function ConditionStructure({
  node,
  nodeParent,
  type,
  index = -1,
  siblingNames = [],
  main = false,
}) {
  const _id = nodeUtils.getID(node);
  const _status = useStatus(_id);

  return (
    <div className={styles["structure"]}>
      <ConditionContainer node={node} status={_status}>
        <ConditionPanel
          node={node}
          nodeParent={nodeParent}
          index={index}
          siblingNames={siblingNames}
          type={type}
        />
        <ConditionMain node={node}>
          <ConditionHeader node={node} siblingNames={siblingNames} main={main} />
        </ConditionMain>
      </ConditionContainer>
    </div>
  );
}

export default ConditionStructure;
